import Carregando from '@/shared/components/Carregando';
import { Fragment, useEffect, useState } from 'react';
import { GetRelatorioNucleo } from '@/modules/reports/relatorio.service';
import { RelatorioNucleoDto } from '@/api.types';
import { toast } from 'react-toastify';

export default function RelatorioNucleosConteudo() {
  const [loading, setLoading] = useState(true);
  const [relatorio, SetRelatorio] = useState<RelatorioNucleoDto[]>([]);

  useEffect(() => {
    GetRelatorioNucleo()
      .then((result) => {
        SetRelatorio(result);
        setLoading(false);
      })
      .catch((res) => {
        toast.error((res as string) + '');
      });
  }, []);

  if (loading) return <Carregando />;

  return (
    <div className="col-12" id="conteudo">
      <h4 className="text-center relatorio-font relatorio-titulo">
        LISTA DE NÚCLEOS
      </h4>
      <br />
      <div className="table-responsive">
        <table id="tabelarelatorio" className="table table-sm table-bordered align-middle mt-3 relatorio-font border border-dark fw-bold" >
          <thead>
            <tr className="text-center fs-5">
              <th>NÚCLEOS</th>
              <th>INTEGRANTES</th>
              <th>ESTAGIÁRIOS</th>
            </tr>
          </thead>
          <tbody>
            {relatorio &&
              relatorio.map((nucleo, index) => {
                const estagiarios = nucleo.lotacoes?.filter(lotacao =>
                  lotacao.estagio !== null && lotacao.estagio !== undefined
                ) || [];

                return (
                  <Fragment key={index}>
                    <tr>
                      <td className="text-center fs-6">
                        {nucleo.nome}
                        <br />
                        ({nucleo.maximoMembros || nucleo.lotacoes?.filter(a => a.defensor)?.length} membros)
                        <br />
                        {nucleo.resolucao}
                      </td>
                      <td>
                        <ul>
                          {nucleo.lotacoes &&
                            nucleo.lotacoes
                              .filter(lotacao => !lotacao.estagio)
                              .sort((a, b) => Number(b.diretor) - Number(a.diretor))
                              .map((lotacao, index2) => {
                                const diretor = lotacao.diretor ? ' - Diretor' : '';
                                let classname = '';
                                if (lotacao.diretor) classname = 'fw-bold ';
                                if (!lotacao.ativo) classname += ' text-decoration-line-through';

                                return (
                                  <li key={index2} className="fw-normal">
                                    <span className={lotacao.ativo ? '' : 'text-decoration-line-through'}>
                                      <span className={classname}>
                                        {lotacao.defensor?.pessoa?.nome}
                                        {diretor}
                                      </span>{' '}
                                      {' - '}
                                      {lotacao.anotacao1}
                                    </span>
                                  </li>
                                );
                              })}
                        </ul>
                      </td>
                      <td>
                        <ul>
                          {estagiarios
                            .sort((a, b) => Number(b.diretor) - Number(a.diretor))
                            .map((estagiario, index3) => {
                              const diretor = estagiario.diretor ? ' - Diretor' : '';
                              let classname = '';
                              if (estagiario.diretor) classname = 'fw-bold ';
                              if (!estagiario.ativo) classname += ' text-decoration-line-through';

                              return (
                                <li key={index3} className="fw-normal">
                                  <span className={estagiario.ativo ? '' : 'text-decoration-line-through'}>
                                    <span className={classname}>
                                      {estagiario.estagio?.estagiario?.pessoa?.nome}
                                      {diretor}
                                    </span>{' '}
                                    {' - '}
                                    {estagiario.anotacao1}
                                  </span>
                                </li>
                              );
                            })}
                        </ul>
                      </td>
                    </tr>
                  </Fragment>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
